export const validateForm = (data) => {
  const newErrors = {};

  // Required fields except sameAsPresent checkbox and fields required only for interns
  for (const key in data) {
    // Skip sameAsPresent checkbox
    if (key === "sameAsPresent") continue;

    // Skip fields required only for interns if joinAs is not intern
    const internOnlyFields = [
      "education",
      "endDate",
      "instituteName",
      "interests",
      "occupation",
      "skills",
      "startDate"
    ];
    if (internOnlyFields.includes(key) && data.joinAs !== "intern") continue;

    // Skip stateOther if state is not "Other"
    if (key === "stateOther" && data.state !== "Other") continue;

    // Skip districtOther if district is not "Other"
    if (key === "districtOther" && data.district !== "Other") continue;

    // idProof is a file, handle separately below
    if (key === "idProof") continue;

    // Check required fields
    if (!data[key]) {
      const label = key.replace(/([A-Z])/g, " $1"); // Insert space before uppercase letters
      newErrors[key] =
        label.charAt(0).toUpperCase() + label.slice(1) + " is required.";
    }
  }

  // Email validation
  if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
    newErrors.email = "Email is not valid.";
  }
  // Age validation for members (at least 18 years old)
  if (data.joinAs === "member" && data.dob) {
    const dob = new Date(data.dob);
    const today = new Date();
    const ageDiff = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    const day = today.getDate() - dob.getDate();
    const age = m < 0 || (m === 0 && day < 0) ? ageDiff - 1 : ageDiff;
    if (age < 18) {
      newErrors.dob = "Member must be at least 18 years old.";
    }
  }

  // Phone number validation (10 digits)
  if (data.phone && !/^\d{10}$/.test(data.phone)) {
    newErrors.phone = "Phone no must be a 10-digit number.";
  }

  if (data.whatsapp && !/^\d{10}$/.test(data.whatsapp)) {
    newErrors.whatsapp = "Whatsapp no must be a 10-digit number.";
  }

  // Pincode validation (6 digits)
  if (data.pincode && !/^\d{6}$/.test(data.pincode)) {
    newErrors.pincode = "Pincode must be a 6-digit number.";
  }

  // Conditional validation for interns (redundant now, but can keep for clarity)
  if (data.joinAs === "intern") {
    // These fields are already checked above in the loop, so this block can be removed or kept for extra checks
  }

  // Consent checkbox must be true
  if (!data.consent) {
    newErrors.consent = "You must agree to abide by the values and mission.";
  }

  // If sameAsPresent is checked, permanentAddress is not required
  if (!data.sameAsPresent && !data.permanentAddress) {
    newErrors.permanentAddress = "Permanent Address is required.";
  }

  return newErrors;
};
